import React from 'react';
import GenericDialog from "@common/GenericDialog";
import axios from "axios";

const AddUserAdminPermsDialog = ({ visible, handleClose, user }) => {
    const addAdminPermission = async (userId) => {
        try {
            await axios.post(`/web/ui/sc/addTeacherAdmin`, userId);
            return true;
        } catch (error) {
            console.error('Error adding admin permissions:', error);
            displayToastMessage('Failed to add admin permissions. Try to remove the permissions again.', null, 'error', undefined, 10000);
            return false;
        }
    };

    const handleAddAdminPermission = async () => {
        const success = await addAdminPermission([user.userId]);
        if (success) {
            displayToastMessage(`Permissions added for ${user?.fullName} successfully.`, null, 'success', undefined, 10000);
            handleClose(true);
        }
    }

    return (
        <GenericDialog
            title={`Add Administrator Permissions`}
            open={visible}
            dialogWidth={450}
            onClose={handleClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: {type: 'text'}
                },
                {
                    name: 'Make Administrator',
                    callback: handleAddAdminPermission,
                    extraProps: {
                        type: 'primary'
                    }
                }
            ]}
        >
            <p><strong>{user?.fullName}</strong> will gain access to all administration functions.</p>
            <p>Are you sure you want to add administrator permissions for this user?</p>
        </GenericDialog>
    );
};

export default AddUserAdminPermsDialog;